var map = {
	"./images/notices/2025/05/braspress-air-cargo–inicia–oficialmente-as–operacoes/02-compressed.png": 8324,
	"./images/notices/2025/05/braspress-air-cargo–inicia–oficialmente-as–operacoes/03-compressed.png": 5471,
	"./images/notices/2025/05/braspress-air-cargo–inicia–oficialmente-as–operacoes/cover.png": 929,
	"./images/notices/2025/12/braspress-air-cargo-completa-6-meses-de-operacoes/cover.png": 1182,
	"./images/notices/2026/06/braspress-air-cargo-ira-iniciar-operacao-noturna/cover.png": 9229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5653;